export const getDaysFromCreateDate = (updatedAt) => {

  if (updatedAt === null || updatedAt === undefined) {
    return 111; //target date over
  }
  const updatedDate = new Date(updatedAt); // Convert to Date object
  const currentDate = new Date(); // Current date

  // Calculate the difference in milliseconds
  const differenceInMs = currentDate - updatedDate;

  // Convert the difference into days, hours, minutes, and seconds
  const differenceInSeconds = Math.floor(differenceInMs / 1000);
  const differenceInMinutes = Math.floor(differenceInSeconds / 60);
  const differenceInHours = Math.floor(differenceInMinutes / 60);
  const differenceInDays = Math.floor(differenceInHours / 24);

  // Get the remaining hours, minutes, and seconds
  //const remainingHours = differenceInHours % 24;
  //const remainingMinutes = differenceInMinutes % 60;
  //const remainingSeconds = differenceInSeconds % 60;

//   console.log(`Difference: ${differenceInDays} days`);
  return differenceInDays;
};
